import type { CommonColumns } from './common_columns';
import { commonColumns } from './common_columns';
import { organizations } from './organizations';

export type OrganizationUsers = CommonColumns & {
  resourceName: string;
  id: string;
  status: string;
  name: string;
  familyName: string;
  givenName: string;
  departmentOneId: string;
  departmentOneName: string;
  departmentTwoId: string;
  departmentTwoName: string;
  departmentThreeId: string;
  departmentThreeName: string;
  identifyingCode: string;
  invitationSentAt: string;
  userId: string;
  userEmail: string;
  speciality: string;
  jobCategory: string;
  dataAnalysisExperience: string;
  emailSubscription: string;
  iconImageUrl: string;
  identicon: string;
  organizationId: string;
  organizationName: string;
  organizationMemo: string;
  companyName: string;
};

// FIXME: refine
export const organizationUsers: Readonly<OrganizationUsers> = {
  ...commonColumns,
  ...{
    resourceName: '組織ユーザー',
    id: '組織ユーザーID',
    status: 'ステータス',
    name: 'ニックネーム',
    familyName: '姓',
    givenName: '名',
    departmentOneId: '部署1ID',
    departmentOneName: '部署1',
    departmentTwoId: '部署2ID',
    departmentTwoName: '部署2',
    departmentThreeId: '部署3ID',
    departmentThreeName: '部署3',
    identifyingCode: '識別コード',
    invitationSentAt: '招待日',
    userId: 'ユーザーID',
    userEmail: 'ユーザーメールアドレス',
    speciality: '専門性',
    jobCategory: '職種',
    dataAnalysisExperience: 'データ分析経験',
    emailSubscription: 'メール受信設定',
    iconImageUrl: 'アイコン',
    identicon: 'デフォルトアイコン',
    organizationId: `${organizations.resourceName}${organizations.id}`,
    organizationName: organizations.name,
    organizationMemo: `${organizations.resourceName}メモ`,
    companyName: organizations.companyName,
  },
};

export const organizationUsersStatuses: ReadonlyArray<string> = [
  'active',
  'inactive',
  'pending',
];

// FIXME: refine
export const organizationUsersStatusesName = (
  status: string | undefined
): string => {
  switch (status) {
    case 'active':
      return '有効 (アクティブ)';
    case 'inactive':
      return '無効 (非アクティブ)';
    case 'pending':
      return '招待中';
    default:
      return '';
  }
};
